import React, { useEffect, useState } from "react";
import { FaWifi } from "react-icons/fa6";
import { useLocation, useNavigate, useParams } from "react-router-dom";

import { Button } from "bootstrap";
import ImageGallery from "../../../component/common/ImageGallery";
import { ReactComponent as LocationIcon } from "../../../assets/location.svg";

import { ReactComponent as ClassRoomIcon } from "../../../assets/classroom.svg";
import { ReactComponent as BedroomIcon } from "../../../assets/bedroom.svg";

import { ReactComponent as ThreaterIcon } from "../../../assets/threater.svg";

import {
  AirIcon,
  AuditoriumsIcon,
  CalenderIcon,
  FavoriteIcon,
  ParkingIcon,
  PartyIcon,
  ProjectIcon,
  ScreenIcon,
  ShareIcon,
} from "./Icons";
import httpServices from "../../../services/httpServices";

const VenueDetail = () => {
  const path = useLocation().pathname;
  const id = path.split("id=")[1];
  const navigate = useNavigate();
  const [venueData, setVenueData] = useState({});

  const getVenueDetails = async () => {
    const { response } = await httpServices.get(`/venue/${id}`, { skip: !id });
    if (response?.status === 200) {
      console.log("venueData", response?.data?.data);
      setVenueData(response?.data?.data);
    }
  };

  useEffect(() => {
    getVenueDetails();
  }, []);

  return (
    <div className="w-full my-4 bg-white px-4 py-4 rounded-[16px] ">
      <div className="w-full ">
        <ImageGallery images={venueData?.venueSnapShot || []} />

        <div className="flex gap-4 flex-wrap mt-4">
          <div className="lg:w-[750px] border-r border-r-[#F0F2F7]">
            <div className="lg:w-[1000px]">
              <div>
                {/* <h1 className=" mb-[10px] sm:text-[26px] text-[22px] md:text-[36px] font-bold">
            AJ Ballroom Section 2
            </h1> */}
                <h1 className="bg-clip-text text-transparent bg-gradient-to-t from-[#2E3E8D] to-[#4DB1E1] text-[22px] xs:text-[26px] inline-block font-semibold mb-[6px]">
                  {venueData?.venueName}
                </h1>

                <div className="flex items-center flex-wrap gap-[10px] mb-[30px]">
                  <div className="flex items-center gap-[10px]">
                    <LocationIcon
                      onClick={() => window.open(venueData?.venueAddressMapUrl)}
                      className="hover:cursor-pointer"
                    />
                    {venueData?.venueAddress}
                  </div>
                </div>
              </div>
            </div>
            <div className="mt-[30px] border-b border-b-[#F0F2F7] pb-4">
              <h2 className="text-[#24252D] font-medium text-lg">
                Description
              </h2>

              <p className="text-sm text-[#626570] mt-3">
                {venueData?.venueDescription}
                <br />
                {/* However, being the home of the famous football club Al Wasl, the
                venue is used exceptionally for football matches today.  Don't
                miss the chance to visit a football match with Al Wasl, that
                used to be trained by football star Maradona. Get to know more
                about upcoming events at Zabeel Stadium and buy tickets here. */}
              </p>
            </div>

            <div className="mt-[30px] border-b border-b-[#F0F2F7] pb-4">
              <h2 className="text-[#24252D] font-medium text-lg mb-3">
                Venue Dimensions
              </h2>
              <div className="flex items-center gap-2.5 flex-wrap">
                {Array.isArray(venueData?.venueDimension) &&
                  (venueData?.venueDimension).map((d) => (
                    <h5 className="px-[10px] py-[6px]  bg-[#F6F6F6] text-[#626570] text-xs rounded-[8px]">
                      {d.name}-{d.value}
                    </h5>
                  ))}
              </div>
            </div>

            <div className="mt-[30px] border-b border-b-[#F0F2F7] pb-4">
              <h2 className="text-[#24252D] font-medium text-lg mb-3">
                Amenities
              </h2>
              <div className="flex items-center flex-wrap gap-[14px]">
                {Array.isArray(venueData?.venueRequiredFacility) &&
                  venueData?.venueRequiredFacility?.map((item, index) => (
                    <div
                      key={index}
                      className="flex items-center justify-center gap-[6px] bg-white border-[0.5px] border-[#AAB3C1] rounded-[10px] p-3 "
                    >
                      {item === "wifi" && <FaWifi className="text-[#74839C]" />}
                      {item === "free parking" && <ParkingIcon />}
                      {/* {item === "Projector screen" && <ScreenIcon />} */}
                      {item === "Air conditioned" && <AirIcon />}
                      {item === "Projector Screen" && <ProjectIcon />}

                      <h6 className="text-[#74839C] text-xs font-poppins font-normal capitalize">
                        {item}
                      </h6>
                    </div>
                  ))}
              </div>
            </div>
            <div className="mt-[30px] border-b border-b-[#F0F2F7] pb-4">
              <h2 className="text-[#24252D] font-medium text-lg mb-3">
                Venue Type
              </h2>
              <div className="flex items-center flex-wrap gap-[14px]">
                {Array.isArray(venueData?.venueType) &&
                  venueData?.venueType?.map((item, index) => (
                    <div className="flex items-center justify-center gap-[6px] bg-white border-[0.5px] border-[#AAB3C1] rounded-[10px] p-3 ">
                      {item === "Part Hall" && <PartyIcon />}
                      {item === "Auditoriums" && <AuditoriumsIcon />}
                      {item === "Banquets" && <PartyIcon />}
                      {item === "Theater Style" && <ThreaterIcon />}
                      <h6 className="text-[#74839C] text-xs font-poppins font-normal capitalize">
                        {item}
                      </h6>
                    </div>
                  ))}
              </div>
            </div>

            <div className="mt-[30px]">
              <h2 className="text-[#24252D] font-medium text-lg mb-3">
                Seating Arrangement
              </h2>
              <div className="flex items-center flex-wrap gap-[14px]">
                {Array.isArray(venueData?.venueSeatingArrangement) &&
                  venueData?.venueSeatingArrangement?.map((item, index) => (
                    <div
                      key={index}
                      className="flex items-center justify-center gap-[6px] bg-white border-[0.5px] border-[#AAB3C1] rounded-[10px] p-3 "
                    >
                      {/* Render icons based on seatingStyle */}
                      {item.seatingStyle === "classroom" && <ClassRoomIcon />}
                      {item.seatingStyle === "boardroom" && <BedroomIcon />}
                      {item.seatingStyle === "theater" && <ThreaterIcon />}

                      {/* Display seating style name */}
                      <h6 className="text-[#74839C] text-xs font-poppins font-normal capitalize">
                        {item.seatingStyle}
                      </h6>
                    </div>
                  ))}
              </div>
            </div>
          </div>
          <div>
            <button
              className="gradian-btn text-white text-center w-[232px] px-3 py-2 text-sm font-medium"
              onClick={() => navigate("/events/add-events")}
            >
              Host an event
            </button>

            <div className="mt-4">
              <h2 className="text-lg font-medium text-[#24252D] mb-2">
                Floor Plan
              </h2>
              <img
                // src={venueData?.venueFloorPlanDesign?.[0]}
                src={`https://zv.shellcode.cloud/upload/${venueData?.venueFloorPlanDesign?.[0]}`}
                alt={`Not Found`}
                className="w-[232px]"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VenueDetail;
